import { put } from 'redux-saga/effects';
import i18next from 'i18next';
import { fetchHomeVideoApi } from 'common/api';
import { getUserEffect } from 'common/sagas/effects/get-user';
import { relatedVideosResetAction } from '../related-videos/actions';
import { videoCommentsResetAction } from '../video-comments/actions';
import {
  updateVideoUploaderInfoAction,
  videoBoxErrorAction,
  videoBoxSuccessAction,
  updateVideoResponsibleUserAction,
} from '../actions';

export function* fetchHomeVideoEffect() {
  yield put(relatedVideosResetAction());
  yield put(videoCommentsResetAction());
  try {
    const resp = yield fetchHomeVideoApi();

    try {
      if (resp.uploaderUserId !== -1) {
        const videoUploader = yield* getUserEffect(resp.uploaderUserId);
        yield put(updateVideoUploaderInfoAction(videoUploader));
      }

      if (resp.responsibleUserId !== -1) {
        const user = yield* getUserEffect(resp.responsibleUserId);
        yield put(updateVideoResponsibleUserAction(user));
      }
    } catch (error) {
      // the user-service can't find users in edge-cases
    }

    yield put(videoBoxSuccessAction(resp));
  } catch (error) {
    yield put(videoBoxErrorAction(i18next.t('video_not_found')));
  }
}
